<template>
  <div>
    <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Name</th>
                <th>Days</th>
                <th>Meetingtype</th>
                <th>Sender address</th>
                <th>&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(reminder, index) in reminders" :key="index">
                <td>{{ reminder.Name }}</td>
                <td>{{ reminder.Days }}</td>
                <td>
                    <span v-if="reminder.MeetingtypeId === 0">All</span>
                    <span v-else-if="reminder.MeetingtypeId === 1">MR</span>
                    <span v-else-if="reminder.MeetingtypeId === 2">WS</span>
                </td>
                <td>{{ reminder.SenderAddress }}</td>
                <td>
                <span class="field is-grouped has-text-right">
                    <span class="control">
                      <a
                        @click="goToReminder(reminder)"
                        class="is-small"
                      >
                        <span class="icon">
                          <font-awesome-icon :icon="['fas', 'edit']" />
                        </span>
                      </a>
                    </span>

                    <span class="control">
                      <a
                        @click="setShowDeleteReminder(reminder)"
                        class="is-small"
                      >
                        <span class="icon has-text-danger">
                          <font-awesome-icon :icon="['fas', 'trash-alt']" />
                        </span>
                      </a>
                    </span>
                  </span>
                </td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mailProvider from '@/providers/mail'

export default {
  components: {
  },

  props: {},

  data() {
    return {
      isLoading: false,
      reminders: [],
    }
  },

  computed: {
    ...mapState('channelStore', ['channel']),
  },

  created() {
    // this.languages.push({ Id: 52, Name: 'Dutch' });
    // this.languages.push({ Id: 65, Name: 'English' });
    // this.languages.push({ Id: 86, Name: 'German' });
    // this.languages.push({ Id: 75, Name: 'French' });
    // this.languages.push({ Id: 156, Name: 'Spanish' });
    // this.languages.push({ Id: 106, Name: 'Italian' });

    this.getChannelReminderMails();
  },

  methods: {
    getChannelReminderMails() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      mailProvider.methods
        .getChannelReminderMails(this.channel.Id)
        .then((response) => {
          if (response.status === 200) {
            this.reminders = response.data;
          }
        })
        .finally(() => {
          this.isLoading = false;
        })
      
    },

    goToReminder(reminder) {
      this.$router.push({
        name: 'configuration-reminder',
        params: {
          reminderId: reminder.Id,
        },
      })
    },

    setShowDeleteReminder(reminder) {
      
    },
  },
}
</script>

<style></style>
